import { render } from "./nearestSpecimen.vue?vue&type=template&id=369ee5c6"
import script from "./nearestSpecimen.vue?vue&type=script&lang=js"
export * from "./nearestSpecimen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__